import axiosInstance from '@/utils/api.js'

var state = {
  contracts: [],
  settingTechParams: [],
  settingTechParamsSlinks: []
}

var getters = {
  CONTRACTS: (state) => {
    return state.contracts
  },
  SETTING_TECH_PARAMS: (state) => {
    return state.settingTechParams
  },
  SETTING_TECH_PARAMS_SLINKS: (state) => {
    return state.settingTechParamsSlinks
  }
}

var mutations = {
  SET_CONTRACTS: (state, payload) => {
    state.contracts = payload
  },
  SET_SETTING_TECH_PARAMS: (state, payload) => {
    state.settingTechParams = payload
  },
  SET_SETTING_TECH_PARAMS_SLINKS: (state, payload) => {
    state.settingTechParamsSlinks = payload
  }
}

var actions = {
  GET_CONTRACTS: async (context, payload) => {
    let result = await axiosInstance.get('/users/contracts?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_CONTRACTS', result.data)
    }
  },
  DOWNLOAD_CONTRACTS: (context, payload) => {
    return axiosInstance.get('/users/contracts/download?is_conv=1&contract_id=' + payload, {responseType: 'blob'})
  },
  CREATE_CONTRACTS: (context, payload) => {
    return axiosInstance.post('/users/contracts', payload)
  },
  CREATE_CONTRACTS_UPLOAD: (context, payload) => {
    return axiosInstance.post('/users/contracts/upload?user_id=' + payload.user_id + '&name=' + payload.name, payload.contents)
  },
  DELETE_CONTRACTS: (context, payload) => {
    return axiosInstance.delete('/users/contracts?contract_id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/contracts.js